import checkIcon from '@src/main/assets/icons/check.svg';
import { Button } from 'primereact/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AcceptButton.module.scss';

interface Props {
  onClick: () => void;
  loading?: boolean;
}

export const AccceptButton: FC<Props> = ({ onClick, loading }) => {
  const { t } = useTranslation();
  return (
    <Button
      label={t('common.accept')}
      icon={<img src={checkIcon} alt={t('common.accept')} width="15" />}
      className={styles.button}
      onClick={onClick}
      loading={loading}
    />
  );
};
